import Component from '../abstracts/Component';
import NewsletterLogic from '../logics/NewsletterLogic';

export default class NewsletterFooterComponent extends Component {
  get SELECTORS() {
    return {
      form: '[data-newsletter-form]',
      input: '[data-newsletter-input]',
      hiddenBlock: '[data-newsletter-hidden-footer]',
      submitButton: '[data-newsletter-submit]',
      emmeCheckbox: '[data-newsletter-emme]',
      privacyCheckbox: '[data-newsletter-privacy]',
      checkSubmitBtn: '[data-newsletter-privacy]',
    };
  }

  get CLASSES() {
    return {
      show: 'show',
      success: 'success',
    };
  }

  constructor(htmlEl) {
    super(htmlEl);
    this.form = this.$component.querySelector(this.SELECTORS.form);
    this.input = this.$component.querySelector(this.SELECTORS.input);
    this.hiddenBlock = this.$component.querySelector(this.SELECTORS.hiddenBlock);
    this.checkSubmitBtn = this.$component.querySelector(this.SELECTORS.checkSubmitBtn);
    this.submitButton = this.$component.querySelector(this.SELECTORS.submitButton);
    this.privacyCheckbox = this.$component.querySelector(this.SELECTORS.privacyCheckbox);
    this.emmeCheckbox = this.$component.querySelector(this.SELECTORS.emmeCheckbox);
    // loading logics
    this.NewsletterLogic = new NewsletterLogic();
  }

  bindEvents() {
    this.NewsletterLogic.manageNewsletterForm(this);

    if (this.input) {
      this.input.addEventListener('focus', () => {
        this.hiddenBlock.classList.add(this.CLASSES.show);
      }, { once: true });
    }
  }

  render() {
    super.render();
    this.bindEvents();
  }

}
